import { useInView } from '@/hooks/useInView';
import { Rocket, Shield, HeartHandshake, Globe, Zap, Users } from 'lucide-react';

const services = [
  { icon: Rocket, title: 'Blitzschnell live', desc: 'Ihre Website geht in wenigen Tagen online, nicht Monaten.' },
  { icon: Shield, title: 'Alles inklusive', desc: 'Hosting, Updates, Sicherheit und Support aus einer Hand.' },
  { icon: HeartHandshake, title: 'Persönliche Betreuung', desc: 'Kein Ticketsystem. Direkte Ansprechpartner, die Ihr Unternehmen verstehen.' },
  { icon: Globe, title: 'Eigene Domain', desc: 'Ihre Wunsch-Domain inklusive. Professionell und einprägsam.' },
  { icon: Zap, title: 'Sorglos-Hosting', desc: 'SSL-Zertifikat, schnelles Hosting und regelmäßige Backups inklusive.' },
  { icon: Users, title: 'Für KMU gemacht', desc: 'Speziell für Klein- und Mittelständische Unternehmen konzipiert.' },
];

export default function VisionSection() {
  const [visionRef, visionInView] = useInView();
  const [servicesRef, servicesInView] = useInView();

  return (
    <>
      <section id="vision" ref={visionRef} data-testid="vision-section" className="relative py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className={`max-w-3xl mx-auto text-center transition-all duration-700 ${visionInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-purple-600 font-['Outfit']">Unsere Vision</span>
            <h2 className="mt-4 text-4xl sm:text-5xl font-light tracking-tight text-slate-900 font-['Outfit']">
              Digitale Präsenz sollte{' '}
              <span className="gradient-text font-normal">selbstverständlich</span> sein
            </h2>
            <p className="mt-6 text-base lg:text-lg leading-relaxed text-slate-500">
              Viele Klein- und Mittelständische Unternehmen kämpfen mit veralteten Websites, teuren Agenturen
              oder komplizierten Baukästen. JF-NEXUS macht Schluss damit. Wir liefern professionelle
              Webpräsenz als Service &mdash; so einfach wie Strom aus der Steckdose.
            </p>
          </div>
        </div>
      </section>

      <section id="leistungen" ref={servicesRef} data-testid="leistungen-section" className="relative py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className={`text-center mb-16 transition-all duration-700 ${servicesInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-purple-600 font-['Outfit']">Leistungen</span>
            <h2 className="mt-4 text-4xl sm:text-5xl font-light tracking-tight text-slate-900 font-['Outfit']">
              Was wir für Sie tun
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {services.map((s, i) => (
              <div
                key={s.title}
                className={`group bg-white/60 backdrop-blur-2xl border border-white/80 shadow-[0_8px_32px_rgba(0,0,0,0.04)] rounded-3xl p-8 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(236,72,153,0.1)] hover:border-pink-200/50 ${
                  servicesInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${i * 80}ms` }}
                data-testid={`service-card-${i}`}
              >
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-500/10 to-pink-500/10 flex items-center justify-center mb-5 group-hover:from-indigo-500/20 group-hover:to-pink-500/20 transition-colors">
                  <s.icon size={22} className="text-purple-600" />
                </div>
                <h3 className="text-lg font-semibold text-slate-900 font-['Outfit']">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-500 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
